/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 20:13:08
 * @Description: 新建/编辑页
 */
'use strict';
angular.module("editPageModule", ['editPageRouterModule']).
    controller('editPageCtrl', ['$scope', '$timeout', '$validation', '$stateParams', '$state', 'localStorageService', 'modalDialog', '$q', 'ueditorService', 'httpService', "$element", "$compile", function ($scope, $timeout, $validation, $stateParams, $state, localStorageService, modalDialog, $q, ueditorService, httpService, $element, $compile) {
        initStatus();
        initData();
        /**
         * [save description] 保存
         * @return {[type]} [description]
         */

        $scope.save = function () {
            $scope.list.bPub = false;
            saveContent().then(function () {
                return validator();
            }).then(function () {
                return save();
            }).then(function (data) {
                if (data.success) {
                    var newId = data.data.id;
                    $scope.list.id = newId;
                    // modalDialog.alertType("", "保存稿件成功", "success", false);
                    modalDialog.success("保存稿件成功", "success", false, function () { }, function () { }, '', 'left0');
                    reFreshListPage();
                    ueditorService.saveToLocal(newId);
                    $state.go("editpage", { id: newId, type: 5 });
                }
            });
        };
        /**
         * [submission description] 投稿
         * @return {[type]} [description]
         */
        $scope.submission = function () {
            $scope.list.bPub = false;
            saveContent().then(function () {
                return validator();
            }).then(function () {
                return save();
            }).then(function (data) {
                if (data.success) {
                    var newId = data.data.id;
                    $scope.list.id = newId;
                    var vparams = {
                        ids: newId
                    };
                    $scope.loadingPromise = httpService.http('/mcnww/web/article/contribute.do', vparams, 'get').then(function (data) {
                        modalDialog.success('投稿成功', 'success', false, function () {
                            reFreshListPage();
                            ueditorService.saveToLocal(newId);
                            window.close();
                        }, function () {}, 2000, 'left0');
                    }, function() {
                        $state.go("editpage", {
                            id: newId,
                            type: 5
                        }, {
                            reload: 'editpage'
                        });
                    });
                }
            });
        };
        /**
         * [save description] 保存方法
         * @return {[type]} [description]
         */
        function save() {
            var deffer = $q.defer();
            $scope.list.articleWordsCount = $scope.list.DOCWORDSCOUNT;
            $scope.loadingPromise = httpService.http("/mcnww/web/article/addEdit.do", $scope.list, "post").then(function (data) {
                deffer.resolve(data);
            });
            return deffer.promise;
        }
        /**
         * [validator description] 表单校验
         * @return {[type]} [description]
         */
        function validator() {
            var deffer = $q.defer();
            $validation.validate($scope.editPageForm).success(function () {
                deffer.resolve();
            }).error(function (result) {
                angular.invalidPosition($scope.editPageForm, $element);
            });
            return deffer.promise;
        }
        /**
         * [saveContent description] 保存正文
         * @return {[type]} [description]
         */
        function saveContent() {
            var deffer = $q.defer();
            ueditorService.saveContent($scope.list);
            if ($scope.list.articleHtmlCon === "") {
                $timeout(function () {
                    //表单校验手动触发
                    $scope.editPageForm.content.$error.content = true;
                    $scope.editPageForm.content.$valid = false;
                    $scope.editPageForm.content.$invalid = true;
                    $scope.editPageForm.$error.content = [$scope.editPageForm.content];
                    $scope.editPageForm.$valid = false;
                    $scope.editPageForm.$invalid = true;
                    deffer.resolve();
                });
            } else {
                deffer.resolve();
            }
            return deffer.promise;
        }
        /**
         * [initStatus description] 初始化参数
         */
        function initStatus() {
            $scope.status = {
                inputData: ''
            };
            $scope.list = {
                id: 0,
                articleTitle: "",
                articleContent: "",
                articleHtmlCon: "",
                articleType: 0,
                firstClassId: "",
                secondClassId: "",
                articleStatus: "",
                remark: '',
            };
        }
        /**
         * [initList description] 初始化表单数据
         * @return {[type]} [description]
         */
        function initList() {
            var deffer = $q.defer();
            if (!!$stateParams.id) {
                getDraftInfo().then(function (result) {
                    for (var i in $scope.list) {
                        $scope.list[i] = result[i];
                    }
                    deffer.resolve();
                });
            } else {
                deffer.resolve();
            }
            return deffer.promise;
        }
        /**
         * [getDraftInfo description] 查询稿件信息
         * @return {[type]} [description]
         */
        function getDraftInfo() {
            var deffer = $q.defer();
            var params = {
                id: $stateParams.id
            };
            $scope.loadingPromise = httpService.http("/mcnww/web/article/findById.do", params, "get").then(function (result) {
                deffer.resolve(result.data);
            });
            return deffer.promise;
        }
        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            getClassicListOneLevel().then(function () {
                return getClassicListTwoLevel();
            }).then(function () {
                return initList();
            }).then(function (data) {
                loadUeditor(data);
                reSelectClassify();
            });

        }
        /**
         * [reSelectClassify description] 选中分类
         * @return {[type]} [description]
         */
        function reSelectClassify() {
            var flag = true;
            for (var i = 0; i < $scope.status.classicListOneLevel.length; i++) {
                if ($scope.status.classicListOneLevel[i].id == $scope.list.firstClassId) {
                    flag = false;
                    $scope.status.selectedOneLevel = angular.copy($scope.status.classicListOneLevel[i]);
                    break;
                }
            }
            if (flag) {
                $scope.status.selectedOneLevel = angular.copy($scope.status.classicListOneLevel[0]);
            }
            flag = true;
            getClassicListTwoLevel().then(function () {
                for (var j = 0; j < $scope.status.classicListTwoLevel.length; j++) {
                    if ($scope.status.classicListTwoLevel[j].id == $scope.list.secondClassId) {
                        flag = false;
                        $scope.status.selectedTwoLevel = angular.copy($scope.status.classicListTwoLevel[j]);
                        break;
                    }
                }
                if (flag) {
                    $scope.status.selectedTwoLevel = $scope.status.classicListTwoLeve === undefined ? $scope.status.selectedTwoLevel : $scope.status.classicListOneLevel.unshift({ name: "请选择" });
                    $scope.status.selectedTwoLevel = angular.copy($scope.status.classicListOneLevel[0]);
                }
            });
        }
        /**
         * [getClassicList description] 获取一级分类
         * @return {[type]} [description]
         */
        function getClassicListOneLevel() {
            var deffer = $q.defer();
            httpService.http("/mcnww/web/classic/classicList.do", "", "get").then(function (data) {
                $scope.status.classicListOneLevel = (function (data) {
                    for (var i in data.data) {
                        data.data[i].name = data.data[i].departName;
                    }
                    return data.data;
                })(data);
                $scope.status.classicListOneLevel.unshift({ name: "请选择" });
                $scope.status.selectedOneLevel = $scope.status.classicListOneLevel[0];
                // $scope.list.firstClassId = $scope.status.selectedOneLevel.id;
                deffer.resolve();
            });
            return deffer.promise;
        }
        $scope.getClassicListTwoLevel = getClassicListTwoLevel;
        /**
         * [getClassicListTwoLevel description] 获取二级分类
         * @return {[type]} [description]
         */
        function getClassicListTwoLevel() {
            var deffer = $q.defer();
            if (!$scope.status.selectedOneLevel) {
                deffer.resolve();
                return deffer.promise;
            }
            var params = {
                id: $scope.status.selectedOneLevel.id,
            };
            httpService.http("/mcnww/web/classic/classicList.do", params, "get").then(function (data) {
                $scope.status.classicListTwoLevel = (function (data) {
                    for (var i in data.sList) {
                        data.sList[i].name = data.sList[i].departName;
                    }
                    return data.sList;
                })(data);
                $scope.status.classicListTwoLevel.unshift({ name: "请选择" });
                $scope.status.selectedTwoLevel = angular.copy($scope.status.classicListTwoLevel[0]);
                $scope.list.secondClassId = angular.isDefined($scope.list.secondClassId) ? $scope.list.secondClassId : undefined;
                $scope.list.firstClassId = $scope.status.selectedOneLevel.id;
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
         * [getTwoLevelid 获取二级分类id]
         * @return {[type]} [description]
         */
        $scope.getTwoLevelid = function () {
            $scope.list.secondClassId = $scope.status.selectedTwoLevel.id;
        };
        /**
         * [loadUeditor description] 加载编辑器
         * @return {[type]} [description]
         */
        function loadUeditor(data) {
            var $ueditor = $("<ueditor></ueditor>");
            var $ueditorLocation = $element.find("ueditorLocation");
            LazyLoad.js(["./static/ueditor/ueditor.config.js?v=11.4", "./static/ueditor/ueditor.all.js?v=11.4"], function () {
                $ueditor.attr({
                    type: data,
                    list: "list",
                    "has-content": "status.hasContent",
                    versionid: $scope.list.id,
                    placeholder: "请输入文章正文",
                    infullscreen: "status.infullscreen"
                });
                $ueditor = $compile($ueditor)($scope);
                $ueditorLocation.append($ueditor);
                var ue = UE.getEditor('ueditor');
                // ue.ready(function(){
                //     ueditorService.drawVideoMark(true, true);
                // });
            });

        }
        /**
         * [reFreshList description] 刷新列表页
         * @return {[type]} [description]
         */
        function reFreshListPage() {
            localStorageService.set("refresh", Math.random());
        }
    }]);